import React, { FC } from "react"
import styled from "styled-components"
import { BrandSpacing, theme } from "../../util/styles/theme"
import { Tag, TagId, TagItem, TagSize, TagVariant } from "../tag/Tag"

export type VariantTagItem = TagItem & { variant?: TagVariant }

export interface TagGroupProps {
  bottomMargin?: BrandSpacing
  className?: string
  onDelete?: (tagId: TagId) => void
  tags: VariantTagItem[]
  size?: TagSize
}

export type ContainerProps = Pick<TagGroupProps, "bottomMargin">

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacings.medium};
  row-gap: ${theme.spacings.small};
  margin-bottom: ${({ bottomMargin }) =>
    bottomMargin && theme.spacings[bottomMargin]};
`

export const TagGroup: FC<TagGroupProps> = ({
  bottomMargin,
  className,
  onDelete,
  tags,
  size,
}) => {
  return (
    <Container className={className} bottomMargin={bottomMargin}>
      {tags.map(t => {
        return (
          <Tag
            key={t.id}
            tag={t}
            onDelete={onDelete}
            variant={t.variant}
            size={size}
          />
        )
      })}
    </Container>
  )
}
